/** PayPal is unavailable for some carts (currency / region restrictions). */
export const PAYPAL_UNSUPPORTED_REGION_CODE = "paypal_unsupported_region"

/** Currencies the storefront will not attempt to load PayPal JS SDK for. */
const PAYPAL_UNSUPPORTED_CURRENCIES = new Set(["cny", "rub"])

/** Country codes where PayPal checkout is disabled in this storefront. */
const PAYPAL_UNSUPPORTED_COUNTRIES = new Set(["cn", "ru"])

export function isPaypalUnsupportedForCart(cart: {
  currency_code?: string | null
  region?: { countries?: Array<{ iso_2?: string | null }> } | null
  shipping_address?: { country_code?: string | null } | null
}): boolean {
  const currency = (cart.currency_code || "").toLowerCase()
  if (PAYPAL_UNSUPPORTED_CURRENCIES.has(currency)) {
    return true
  }

  const shippingCountry = cart.shipping_address?.country_code?.toLowerCase()
  if (shippingCountry && PAYPAL_UNSUPPORTED_COUNTRIES.has(shippingCountry)) {
    return true
  }

  const countries =
    cart.region?.countries
      ?.map((c) => c.iso_2?.toLowerCase())
      .filter(Boolean) ?? []

  if (
    countries.length > 0 &&
    countries.every((code) => PAYPAL_UNSUPPORTED_COUNTRIES.has(code as string))
  ) {
    return true
  }

  return false
}
